// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3jDmN","label":"Labeled_label__3ljEG","divider":"Labeled_divider__x2ieL"};